export default "__VITE_ASSET__JSDCfq5J__"